import { defineMessages } from "react-intl";

const messages = defineMessages({
  saveChanges: {
    id: "companyRecordPane.details.saveButton.changed",
    defaultMessage: "Save Changes",
    description: "Save button label if form changed",
  },
  saved: {
    id: "companyRecordPane.saveButton.notChanged",
    defaultMessage: "Saved",
    description: "Save button label if form did not changed",
  },
  title: {
    id: "companyRecordPane.details.title",
    defaultMessage: "Details",
    description: "Company details tab title",
  },
});

export default messages;
